import { AuthMessage, AuthMessageType } from '@playcastdotio/Messaging';
import { setIsReady } from '..';

type SignInTokenCallback = (token: string) => void;
let signInTokenCallback: SignInTokenCallback | null = null;

export const setSignInTokenCallback = (callback: SignInTokenCallback) => {
  signInTokenCallback = callback;
};

export const handleAuthMessage = (message: AuthMessage) => {
  console.log('[Auth] Received auth message:', message);

  switch (message.type) {
    case AuthMessageType.AUTH_SUCCESS: {
      console.log('Auth success');
      setIsReady(true);
      break;
    }
    case AuthMessageType.AUTH_SIGNIN_TOKEN_REPLY: {
      if (signInTokenCallback && message.token) {
        signInTokenCallback(message.token);
      }
      break;
    }
    default: {
      console.warn('[Auth] Unknown auth message type:', message.type);
    }
  }
};
